/**
 * Calendar dates - `YYYY-MM-DD`, no time, no zone - as the date picker reads
 * and writes them (CAP-862).
 */

const WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

/** `YYYY-MM-DD` as local midnight, or undefined for anything that is not a real date. */
export function parseCalendarDate(value: string | null | undefined): Date | undefined {
  const match = value ? /^(\d{4})-(\d{2})-(\d{2})$/.exec(value) : null
  if (!match) return undefined
  const [year, month, day] = [Number(match[1]), Number(match[2]), Number(match[3])]
  const date = new Date(year, month - 1, day)
  // Rejects 2026-02-30 instead of quietly rolling it over to 2 March.
  return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day
    ? date
    : undefined
}

/** The local calendar date of `date` as `YYYY-MM-DD`. */
export function toCalendarDate(date: Date): string {
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
}

/** "Mon 12 Oct", or "Mon 12 Oct 2027" outside `today`'s year - the board's own spelling. */
export function formatPickedDate(value: string, today?: string | null): string | null {
  const date = parseCalendarDate(value)
  if (!date) return null
  const stem = `${WEEKDAYS[date.getDay()]} ${date.getDate()} ${MONTHS[date.getMonth()]}`
  const thisYear = today ? Number(today.slice(0, 4)) : new Date().getFullYear()
  return date.getFullYear() === thisYear ? stem : `${stem} ${date.getFullYear()}`
}
